import { BoxList, StatusLabel, StatusLabelTypes } from '@factorialco/deprecated-design-system'
import { F0Box, F0AvatarPerson, F0TagStatus, F0Text, StatusVariant } from '@factorialco/f0-react'
import { DocumentStatusesEnum } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import StatusItem, {
  StatusStruct,
} from 'modules/documents/components/DocumentPreview/Content/StatusItem'
import type Log from 'modules/documents/store/models/Log'

interface Props {
  statusChangedLog: Log | undefined
  documentStatus: DocumentStatusesEnum
  employeeFullName: string
  employeeAvatarURL: string
  useF0?: boolean
}

const Status = ({
  statusChangedLog,
  documentStatus,
  employeeFullName,
  employeeAvatarURL,
  useF0 = false,
}: Props) => {
  const toStatusStruct = (): StatusStruct => {
    return {
      signerFullName: employeeFullName,
      signerAvatar: employeeAvatarURL,
      statusText: getStatusText(documentStatus),
      statusDate: statusChangedLog?.attributes.created_at,
    }
  }

  const getTagColor = (status: DocumentStatusesEnum): StatusLabelTypes => {
    if (status === 'to_fill') return 'warning'
    if (status === 'filled') return 'positive'

    return 'info'
  }

  const getF0Variant = (status: DocumentStatusesEnum): StatusVariant => {
    if (status === 'to_fill') return 'warning'
    if (status === 'filled') return 'positive'

    return 'info'
  }

  const getStatusText = (status: DocumentStatusesEnum): string => {
    return {
      to_fill: i18n.t('documents.modal.fillable.status.to_fill'),
      filled: i18n.t('documents.modal.fillable.status.filled'),
    }[status]
  }

  if (useF0) {
    const statusDate = statusChangedLog?.attributes.created_at
    const formattedDate = statusDate
      ? i18n.t('documents.modal.esignature.status_date', {
          status: getStatusText(documentStatus),
          date: new Date(statusDate).toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          }),
        })
      : undefined

    return (
      <F0Box
        display="flex"
        padding="md"
        gap="sm"
        border="default"
        borderColor="default"
        borderRadius="md"
        flexDirection="row"
        alignItems="center"
        justifyContent="between"
      >
        <F0Box display="flex" flexDirection="row" alignItems="center" gap="sm">
          <F0AvatarPerson
            src={buildUrl(employeeAvatarURL)}
            firstName={employeeFullName.split(' ')[0] || ''}
            lastName={employeeFullName.split(' ').slice(1).join(' ') || ''}
          />
          <F0Box gap="xs">
            <F0Text variant="body" content={employeeFullName} />
            {formattedDate && <F0Text variant="description" content={formattedDate} />}
          </F0Box>
        </F0Box>
        <F0TagStatus text={getStatusText(documentStatus)} variant={getF0Variant(documentStatus)} />
      </F0Box>
    )
  }

  return (
    <BoxList>
      <StatusItem
        status={toStatusStruct()}
        statusBox={
          <StatusLabel ellipsis type={getTagColor(documentStatus)}>
            {getStatusText(documentStatus)}
          </StatusLabel>
        }
      />
    </BoxList>
  )
}

export default Status
